import { AssigneeGroupListItem } from './AssigneeGroupService'
import type { AssigneeGroupAction } from './actions'
import { GET_ASSIGNEE_GROUPS } from './actions'

const INITIAL_STATE: AssigneeGroupListItem[] = []

const assigneeGroups = (
  state = INITIAL_STATE,
  action: AssigneeGroupAction,
): AssigneeGroupListItem[] => {
  switch (action.type) {
    case GET_ASSIGNEE_GROUPS:
      return action.assigneeGroups
    // GET_ASSIGNEE_GROUPS_ERROR: keep the last-good list. The slice is typed as
    // AssigneeGroupListItem[]; the previous `{ ...state, error }` turned it into a plain
    // object, which then crashed array consumers (e.g. Inbox's `[...assigneeGroups]`).
    default:
      return state
  }
}

export default assigneeGroups
